module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-4-0630f7a30667033b90351b333454d0c3.jpg";